export default __webpack_public_path__ + "static/media/create-board-icon.b66763d8.svg";